import {
  GeoJSONFeature
} from 'maplibre-gl';

import { geojsonTypes, updateActions, events } from './utils/constants';
import difference from '@turf/difference';
import { drawModes, drawState } from '../../Types';

const CutPolygonMode = <drawModes>{};

CutPolygonMode.onSetup = function () {
  const main = this.getSelected()
    .filter((f:any) => f.type === 'Polygon' || f.type === 'MultiPolygon')
    .map((f:any) => f.toGeoJSON());

  if (main.length < 1) {
    // document.getElementsByClassName('geobox-gl-hole-icon')[0].checked = false;
    throw new Error(
      'Please select a feature/features (Polygon or MultiPolygon) to create hole!',
    );
  }

  return {
    main,
  };
};

CutPolygonMode.toDisplayFeatures = function (state:drawState, geojson:GeoJSONFeature, display:any) {
  display(geojson);

  this.changeMode('passing_mode_polygon', (cuttingpolygon:drawModes) => {
    state.main.forEach((feature:any) => {
      if (
        feature.geometry.type === geojsonTypes.POLYGON
        || feature.geometry.type === geojsonTypes.MULTI_POLYGON
      ) {

        const afterCut = difference(feature, <any>cuttingpolygon);
        const newF = this.newFeature(afterCut);
        newF.id = feature.id;
        this.addFeature(newF);
        this.fireUpdate(newF);
      } else {
        throw new Error("The feature is not Polygon/MultiPolygon!");
      }
    });
  });
};



CutPolygonMode.fireUpdate = function (newF:any) {
  // document.getElementsByClassName('geobox-gl-hole-icon')[0].checked = false;
  
  this.map.fire(events.UPDATE, {
    action: updateActions.CHANGE_COORDINATES,
    features: newF.toGeoJSON(),
  });

  // setTimeout(() => {
  //   this.map._updateCoordinateTable();
  // }, 400);
  
};

export default CutPolygonMode;